import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a389496a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "DNASequenceRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "作为一名生物学家，正在探索一种未知生物的DNA。你需要分析的是一条包含6组碱基配对的DNA片段， 每组配对用两个字母表示，并由若干个未知规则限定。目前你已知4个规则，每个规则中的2个字母必须成对出现， 例如规则中包含A-N配对，那么字母A或者N就不能和其他字母配对。 你将通过这4个规则来判断DNA片段是否正确。需要注意的是，不是所有4个已知规则都会出现在DNA片段中; DNA片段中也会存在未出现在4个已知规则中的字母，这些字母之间的配对默认为正确。此外，同一配对中的字母交换位置不影响配对正确性。", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft16 mr8"
}, "已知规则（必须成对出现）：", -1));
const _hoisted_5 = {
  class: "rules"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观察上面这 6 组配对，如果有一组违反规则就选 错误，否则选 正确", -1));
const _hoisted_7 = {
  class: "bothCenter mt16"
};
const _hoisted_8 = {
  class: "ft22"
};
const _hoisted_9 = {
  class: "flex flex-col"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_DnaHelix = _resolveComponent("DnaHelix");
  const _component_AnswerButtonGroup = _resolveComponent("AnswerButtonGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rules, (rule, ri) => {
      return _openBlock(), _createElementBlock("span", {
        key: `rule_${ri}_${rule}`,
        class: "rule-chip"
      }, _toDisplayString(rule), 1);
    }), 128))])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt20"
  }, {
    default: _withCtx(() => [_createVNode(_component_DnaHelix, {
      pairs: $props.data.pairs,
      width: 720,
      height: 220
    }, null, 8, ["pairs"])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt20"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [(_openBlock(), _createBlock(_component_AnswerButtonGroup, {
    onChoose: $options.onChoosed,
    "option-both-center": false,
    review: $props.review,
    reviewMode: $props.reviewMode,
    key: `DNASequence_${$props.data.questionIndex}`,
    options: $options.options
  }, {
    default: _withCtx(btnIndex => [_createElementVNode("span", _hoisted_8, _toDisplayString($options.options[btnIndex.index]), 1)]),
    _: 1
  }, 8, ["onChoose", "review", "reviewMode", "options"]))]), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt16"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, "正确答案：" + _toDisplayString($options.words[$props.data.rightAnswer]), 1), $props.review ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      style: _normalizeStyle({
        color: $props.review.result ? 'green' : 'red'
      })
    }, "您的答案：" + _toDisplayString($options.words[$props.review.answer]), 5)) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}